import { render, staticRenderFns } from "./DadosEnvio.vue?vue&type=template&id=61e283ce"
import script from "./DadosEnvio.vue?vue&type=script&lang=js"
export * from "./DadosEnvio.vue?vue&type=script&lang=js"
import style0 from "./DadosEnvio.vue?vue&type=style&index=0&id=61e283ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports